function initializeCustomerFeedback() {
  var form = document.getElementById('customers-feedback-form-11');
  if (!form || form.dataset.feedbackInitialized) return;
  var button = form.querySelector('#customers-feedback-form-btn-11');
  var status = form.querySelector('#success-feedback-11');
  var confirmation = document.getElementById('success--alert--10');
  if (!button || !status || !confirmation) return;
  form.dataset.feedbackInitialized = 'true';
  var sending = false;
  var originalLabel = button.textContent;

  function showMessage(element, message, isError) {
    element.textContent = message;
    element.style.color = isError ? '#b91c1c' : '#047857';
    element.setAttribute('tabindex', '-1');
    element.setAttribute('role', isError ? 'alert' : 'status');
    element.style.display = 'block';
    element.focus({ preventScroll: true });
    element.scrollIntoView({ block: 'center' });
  }

  function validateForm() {
    var firstInvalid = null;
    form.querySelectorAll('.quest_ans_error').forEach(function (error) {
      error.textContent = '';
    });
    form.querySelectorAll('.naming_tab input[type="text"]').forEach(function (input) {
      if (!input.value.trim()) {
        input.closest('.customers-feedback-answer').querySelector('.quest_ans_error').textContent = 'This field is required';
        firstInvalid = firstInvalid || input;
      }
    });
    form.querySelectorAll('.customers-feedback-tab:not(.naming_tab)').forEach(function (tab) {
      var radio = tab.querySelector('input[type="radio"]');
      var textarea = tab.querySelector('textarea');
      var message = '';
      if (radio && !tab.querySelector('input[type="radio"]:checked')) {
        message = 'Please choose your answer';
        firstInvalid = firstInvalid || radio;
      }
      if (textarea && !textarea.value.trim()) {
        message = 'Please enter your comments';
        firstInvalid = firstInvalid || textarea;
      }
      if (message) tab.querySelector('.quest_ans_error').textContent = message;
    });
    if (firstInvalid) firstInvalid.focus();
    return !firstInvalid;
  }

  async function sendFeedback(event) {
    event.preventDefault();
    if (sending || !validateForm()) return;
    sending = true;
    button.disabled = true;
    button.textContent = 'Sending...';
    status.textContent = '';
    form.setAttribute('aria-busy', 'true');
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 30000);

    try {
      var body = new URLSearchParams(new FormData(form));
      if (!body.get('page_title')) {
        var heading = document.querySelector('h1');
        body.set('page_title', heading ? heading.textContent.trim() : document.title);
      }
      if (!body.get('page_url')) {
        body.set('page_url', window.location.origin + window.location.pathname);
      }
      var response = await fetch('https://chemtech-app.codesdesk.com/api/feedback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
        body: body.toString(),
        signal: controller.signal
      });
      var data = await response.json().catch(function () { return null; });
      if (!response.ok || !data || data.ok !== true) {
        throw new Error(data && data.message || 'Sorry, your feedback could not be sent. Please try again later.');
      }
      form.style.display = 'none';
      showMessage(confirmation, confirmation.textContent.trim() || data.message || 'Thank you for your feedback.', false);
    } catch (error) {
      var message = error.name === 'AbortError' || error instanceof TypeError
        ? 'We could not confirm receipt of your feedback. Please contact us before submitting again.'
        : error.message;
      showMessage(status, message, true);
    } finally {
      clearTimeout(timeout);
      sending = false;
      button.disabled = false;
      button.textContent = originalLabel;
      form.removeAttribute('aria-busy');
    }
  }

  // Support both older type="button" markup and native form submission.
  button.addEventListener('click', sendFeedback);
  form.addEventListener('submit', sendFeedback);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCustomerFeedback);
} else {
  initializeCustomerFeedback();
}
document.addEventListener('shopify:section:load', initializeCustomerFeedback);

$(document).ready(function(){

  function manage_quantity_onpage_load(){  
    $('.tab_product_form tbody tr ').each(function(){  
      var mainThis = $(this); 
      var quant = mainThis.find('.product-quantity-block').find('.cdk-quantity-box').find('.prod_quantity').val();
      quant = parseInt(quant); if(quant > 1){   }  else { quant = 1;  }
      mainThis.find('.cdk-addToCart').attr('data-item-quantity',quant);     
    }) 
  }  
  manage_quantity_onpage_load()
  //Ajax Add To Cart Function Start
  function ajaxAddToCart(id, quantity) {
    var dynamicData = "quantity="+quantity+"&id="+id;
    return $.ajax({
      url: "/cart/add.js",
      type: "get",
      data: dynamicData,
      dataType: "json",
      beforeSend: function() {
        //console.log('loading');  
      },
      error: function(jqXHR, textStatus, errorThrown) {
        if(jqXHR.status == 400) { alert(jqXHR.responseJSON.message); }
      }
    });
  }


  //Ajax Cart Count Function Start
  function cartCount(){ $.getJSON('/cart.js', function(cart) { $("header #cart .cart-count").html(cart.item_count);});}
  cartCount();
  //Ajax Cart Count Function End

  // Add To Cart Button Jquery Start
  function manage_addtocart_success_popup(currentThis,responseData){
    var productName = responseData.product_title;       var productQty = currentThis.attr('data-item-quantity');
    var variantOptionName = responseData.variant_title; var variantFeaturedImage = responseData.image;
    var price = responseData.price;
    var totlaprice= responseData.line_price;
    var variantPrice = '<span class="money">'+Shopify.formatMoney(price)+'</span>' ;  
    var variantTitle = responseData.variant_title;  var variantTitleHtml = '';
    if(variantTitle != '' && variantTitle != null){

      for(var i=0;i<responseData.options_with_values.length;i++){
        var optionName = responseData.options_with_values[i].name;var optionValue = responseData.options_with_values[i].value;
        variantTitleHtml +='<p class="options">'+optionName+': <span class="cdk-p-options ">'+optionValue+'</span></p>';
      }         
    }
    console.log('productName :: '+productName);
    $('.addtocart--success-popup--modal .cdk-model-content .content--block .image-block img').attr('src',variantFeaturedImage);
    $('.addtocart--success-popup--modal .cdk-model-content .content--block .detail-block .cdk-modal-title').html(productName);
    $('.addtocart--success-popup--modal .cdk-model-content .content--block .detail-block .cdk-product-price').html(variantPrice);
    $('.addtocart--success-popup--modal .cdk-model-content .content--block .detail-block .product--choose-option-block').html(variantTitleHtml);
    $('.addtocart--success-popup--modal .cdk-model-content .content--block .detail-block .cdk-p-quantity').html(productQty);
  }
  $(document).on("click", ".cdk-addToCart", function(p) {
    p.preventDefault(); var currentThis = $(this);
    var quantity = parseInt($(this).attr('data-item-quantity')),
        id = $(this).attr('data-varient-id');
    ajaxAddToCart(id, quantity).done(function(data) {
      console.log(JSON.stringify(data));
      var responseData = data;
      $('.cdk-modal-overlayer, .act-success-modal').addClass('active');
      manage_addtocart_success_popup(currentThis,responseData);   
      cartCount();
    });
  });

  // Add To Cart Button Jquery End

  $('body').on('click', '.cdk-modal-overlayer.active, .cdk-model-body .modal-close', function(){
    $('.cdk-modal-overlayer').removeClass('active');
    $('.cdk-model-body').removeClass('active');
  })

  $(document).on("click", ".product-quantity-block .cdk-quantity-box .cdk-q-btnleft .decrease--quantity", function(){
    var quant = $(this).parents('.cdk-quantity-box').find('.cdk-q-input').find('.prod_quantity').val();
    quant = parseInt(quant);    
    if(quant > 1){  quant = quant-1; }  else { quant = 1;  }
    $(this).parents('.cdk-quantity-box').find('.cdk-q-input').find('.prod_quantity').val(quant);
    $(this).parents('.tab_product_form ').find('.cdk-addToCart').attr('data-item-quantity',quant); 
  })  
  $(document).on("click", ".product-quantity-block .cdk-quantity-box .cdk-q-btnright .increase--quantity", function(){
    var quant = $(this).parents('.cdk-quantity-box').find('.cdk-q-input').find('.prod_quantity').val();
    quant = parseInt(quant); 
    if(quant >= 1){  quant = quant+1; } else { quant = 1;  }  
    $(this).parents('.cdk-quantity-box').find('.cdk-q-input').find('.prod_quantity').val(quant);
    $(this).parents('.tab_product_form ').find('.cdk-addToCart').attr('data-item-quantity',quant); 
  })

  $(document).on("click", ".cdk-quantity-box .cdk-q-btnleft .c_decrease--quantity", function(){
    var quant = $(this).parents('.cdk-quantity-box').find('.cdk-q-input').find('.cart_quantity').val();
    quant = parseInt(quant); 
    console.log('quant'+quant);
    if(quant > 1){  quant = quant-1; }  else { quant = 0;  }
    $(this).parents('.cdk-quantity-box').find('.cdk-q-input').find('.cart_quantity').val(quant);
    $( "input[name='update']" ).trigger( "click" );
  })  
  $(document).on("click", ".cdk-quantity-box .cdk-q-btnright .c_increase--quantity", function(){
    var quant = $(this).parents('.cdk-quantity-box').find('.cdk-q-input').find('.cart_quantity').val(); 
    quant = parseInt(quant); 
    console.log('quant'+quant);
    if(quant >= 1){  quant = quant+1; } else { quant = 1;  }
    $(this).parents('.cdk-quantity-box').find('.cdk-q-input').find('.cart_quantity').val(quant);
    $( "input[name='update']" ).trigger( "click" );
  })
$(document).on("click", "#filter_height", function(){
   $(this).toggleClass('See More');
  if($(this).hasClass('SeeMore')){
        $(this).text('See More');         
    } else {
        $(this).text('See Less');
    }
   $(this).parents('.filter').find('.short_filter_list li').toggleClass('show');
   // $(this).parents('.filter').find('.filter_full_list').toggleClass('show'); 
  });
});
